import MenuIcon from '@mui/icons-material/Menu';
import { AppBar, Container, Menu, Toolbar, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import { Box } from '@mui/system';
import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { pages } from '../consts/types/pages';
import Logo from './Logo';
import UserAvatar from './UserAvatar';
;

interface AppBarProps {
}

type Props = AppBarProps;


const AppBarComp: FC<Props> = (props: Props) => {
    const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null);
    const navigate = useNavigate();

    const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };
    return <AppBar position="sticky" sx={{ top: 0, backgroundColor: "white", boxShadow: "none" }}>
        <Container maxWidth="xl">
            <Toolbar disableGutters >
                <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" }, }}>
                    <Logo />
                </Box>
                <Box sx={{ display: { xs: 'none', md: 'flex' }, color: "#20264a" }}>
                    <UserAvatar />
                    {pages.map((page) => (
                        <Button
                            key={page.name}
                            onClick={() => {
                                handleCloseNavMenu();
                                navigate(page.url)
                            }}
                            sx={{ my: 2, color: 'inherit', display: 'block', fontFamily: "Montserrat" }}
                        >
                            {page.name}
                        </Button>
                    ))}

                </Box>
                <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" }, }} my={1}>
                    <Logo />
                </Box>
                <Box sx={{ display: { xs: 'flex', md: 'none' }, color: "#20264a" }}>
                    <UserAvatar />
                    <IconButton
                        size="large"
                        aria-label="account of current user"
                        aria-controls="menu-appbar"
                        aria-haspopup="true"
                        onClick={handleOpenNavMenu}
                        color="inherit"
                    >
                        <MenuIcon />
                    </IconButton>
                    <Menu
                        id="menu-appbar"
                        anchorEl={anchorElNav}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                        }}
                        keepMounted
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                        }}
                        open={Boolean(anchorElNav)}
                        onClose={handleCloseNavMenu}
                        sx={{
                            display: { xs: 'block', md: 'none' },
                        }}
                    >
                        {pages.map((page) => (
                            <MenuItem key={page.name}
                                onClick={() => {
                                    handleCloseNavMenu();
                                    navigate(page.url);
                                }}
                            >
                                <Typography textAlign="center" fontFamily="Montserrat">{page.name}</Typography>
                            </MenuItem>
                        ))}
                    </Menu>
                </Box>
            </Toolbar>
        </Container>
    </AppBar>;
}


export default AppBarComp;

